import CheckIcon from '@mui/icons-material/CheckCircle'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import noop from 'lodash/noop'
import omit from 'lodash/omit'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import withUser from '../../auth/withUser'
import type { Station } from '../../station/stationTypes'
import withActiveStation from '../../station/withActiveStation'
import type { User } from '../users/userTypes'
import { availableVitrineProductsQuery, deleteVitrineProduct } from './vitrineProductQueries'
import css from './vitrineProductTable.css'
import type { VitrineProduct } from './vitrineProductTypes'
type Props = {
  data: VitrineProduct
  onEdit: (...args: Array<any>) => any
  activeStation: Station
  user: User
}

const updateCacheOnDelete = (id: string, stationId: string) => (cache: any) => {
  const { availableVitrineProducts } = cache.readQuery({
    query: availableVitrineProductsQuery,
    variables: {
      stationId,
    },
  })
  cache.writeQuery({
    query: availableVitrineProductsQuery,
    variables: {
      stationId,
    },
    data: {
      availableVitrineProducts: [...availableVitrineProducts.filter((vitrineProduct) => vitrineProduct.id !== id)],
    },
  })
}

@withUser
@withActiveStation
class VitrineProductRow extends React.PureComponent<Props> {
  onDelete = (onMutate: (...args: Array<any>) => any, id: string) => {
    const { activeStation } = this.props
    onMutate({
      variables: {
        id,
      },
      update: updateCacheOnDelete(id, activeStation.id),
    })
  }

  render() {
    const { data, onEdit } = this.props
    // products that don't have a station are imported from Apaja and thus can't be edited in Mojova
    const allowModify = data.station
    return (
      <TableRow>
        <TableCell className={css.tableCell}>{data.name}</TableCell>
        <TableCell className={css.tableCell}>
          <CheckIcon className={!data.station ? css.checkIconChecked : css.checkIcon} />
        </TableCell>
        <TableCell className={css.actionsCell}>
          {allowModify && (
            <React.Fragment>
              <EditButton onClick={() => (data.id && data.station ? onEdit(omit(data, ['__typename'])) : noop)} />
              <Mutation mutation={deleteVitrineProduct}>
                {(onMutate) => <DeleteButton onClick={() => (data.id ? this.onDelete(onMutate, data.id) : noop)} />}
              </Mutation>
            </React.Fragment>
          )}
        </TableCell>
      </TableRow>
    )
  }
}

export default VitrineProductRow
